import { render, staticRenderFns } from "./Pumproom-management.vue?vue&type=template&id=4b49964c&scoped=true"
import script from "./Pumproom-management.vue?vue&type=script&lang=js"
export * from "./Pumproom-management.vue?vue&type=script&lang=js"
import style0 from "./Pumproom-management.vue?vue&type=style&index=0&id=4b49964c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b49964c",
  null
  
)

export default component.exports